import { Injectable } from '@angular/core';
import {Web} from '../models/web';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

const datasevice = 'assets/data/mock-web-data.json';

@Injectable({
  providedIn: 'root'
})
export class WebService {

  web: Web = new Web();

  constructor(private http: HttpClient) { }

  getWb(): Observable<HttpResponse<Web[]>> {
    return this.http.get<Web[]>(
      datasevice, {observe: 'response'}
    );
}}
